import React from 'react';
import { InPageNavigationStyles as S } from './InPageNavigation.styles';
const InPageNavigation = ({ items, title }) => {
    return (React.createElement(S.Container, { innerWidth: "narrow", flush: "both" },
        title && React.createElement(S.Title, null, title),
        items && (React.createElement(S.AnchorList, null, items.map((item, index) => (React.createElement(S.AnchorItem, { key: `anchor-${index}` },
            React.createElement("a", { href: `#${item.anchorId}` }, item.text))))))));
};
export default InPageNavigation;
